import type { SparklineProps } from '../../core/components/sparkline-display/types/sparkline-props.js';

/**
 * Slot props for the sparkline component within SingleValueGrid.
 * @public
 */
export interface SingleValueGridSparklineProps
  extends Omit<SparklineProps, 'data' | 'loading'> {
  /** Accessor function or string to retrieve the data for the sparkline. */
  dataAccessor?: string;
  /** Accessor function to retrieve the color of the sparkline. */
  colorAccessor?: string;
}

/**
 * @public
 */
export const Sparkline = (props: SingleValueGridSparklineProps) => null;

Sparkline['displayName'] = 'SingleValueGrid.Sparkline';
